import React, { useState, useEffect } from "react";
import "./Header.css";
import "../Header/Header.css";
import { showSuccessToast } from "../../assets/toastUtils";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logoimg from "../../assets/images/Mountain-mystries-logo.png";
import { DisabledTextButton } from "../Buttons/Buttons";
import { Link } from "react-router-dom";
import LoginBtn from "../Login/LoginBtn";
import AccountDetailDropdown from "../Login/AccountDetailDropdown";

function Header() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hideToggle, setHideToggle] = useState(false);
  const navigate = useNavigate();
  const handleShowToggle = () => {
    setHideToggle(!hideToggle);
  };
  const [accountDetails, setAccountDetails] = useState(false);
  const handleOnClick = (e) => {
    e.preventDefault();
    setAccountDetails(!accountDetails);
  };
  const [loginDetails, setLoginDetails] = useState(false);
  const handleOnClickLogIn = (e) => {
    e.preventDefault();
    setLoginDetails(!loginDetails);
  };

  // console.log("isLoggedIn", isLoggedIn);
  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();
    localStorage.clear();
    navigate("/");
    window.location.reload();
    showSuccessToast("Logged Out Successful");
    // alert("test")
    // setLoader(true);
    // const token = localStorage.getItem("token");
    // const myHeaders = new Headers();

    // myHeaders.append("key", "D4X50uU40Vz4pweFLEmsoiJy107iPfTD4ompprop1");
    // myHeaders.append("Authorization", `Bearer ${token}`);
    // const requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   redirect: "follow",
    // };

    // try {
    //   const response = await fetch(
    //     "https://extranet.travcatalyst.com/api/v1/customers/logout",
    //     requestOptions
    //   );
    //   const result = await response.json();
    //   console.log(result);

    //   showSuccessToast("Logged Out Successful")
    //   localStorage.clear()
    //   setIsLoggedIn(false);
    //   // navigate("/login")
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setLoader(false);
    // }
  };

  const customButtonStyles = {
    fontSize: "12px",
    fontWeight: "500",
  };

  // useEffect(() => {
  //   const updateHideToggle = () => {
  //     if (window.innerWidth <= 640) {
  //       setHideToggle(false);
  //     } else {
  //       setHideToggle(true);
  //     }
  //   };

  //   updateHideToggle(); // Set the initial state based on screen size
  //   window.addEventListener("resize", updateHideToggle);

  //   return () => window.removeEventListener("resize", updateHideToggle);
  // }, []);

  const [customerData, setCustomerData] = useState([]);
  const [agentData, setAgentData] = useState([]);

  const [name, setName] = useState("");
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const storedUserDetails = localStorage.getItem("userDetails");
    if (storedUserDetails) {
      const userDetails = JSON.parse(storedUserDetails);
      // console.log(userDetails);

      setName(userDetails.name);
    }

    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);
  const closePriceDetails = (id) => {
    setHideToggle(false);
  };

  // Active
  const [activeLink, setActiveLink] = useState("");
  // console.log("activeLink", activeLink);

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    const searchParams = new URLSearchParams(location.search);

    // Check if 'hotel' is present in the URL parameters
    const hotelInParams = searchParams
      .toString()
      .toLowerCase()
      .includes("hotel");

    // Set 'hotel' active if on accommodation page or 'hotel' in params
    if (path.includes("accommodation") || hotelInParams) {
      setActiveLink("hotel");
    }
    // Set 'holidays' active if on home page or 'holidays' in params
    else if (path === "/" || path.includes("holidays")) {
      setActiveLink("holidays");
    } else if (path === "/activities" || path.includes("activities")) {
      setActiveLink("activities");
    } else if (path === "/transport" || path.includes("transport")) {
      setActiveLink("transport");
    }
  }, [location.pathname, location.search]);

  const handleActive = (link) => {
    setActiveLink(link);
  };

  return (
    <header>
      <button className="toggle_menu_icon" onClick={handleShowToggle}>
        <svg
          width="18"
          height="13"
          viewBox="0 0 18 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 12.5V10.5H18V12.5H0ZM0 7.5V5.5H18V7.5H0ZM0 2.5V0.5H18V2.5H0Z"
            fill="#fff"
          />
        </svg>
      </button>
      <div className="container">
        <div className="flex_align_center justify_content_between HeaderMain-content">
          <div className="Header-main">
            <div style={{ width: "65px" }}>
              <NavLink className="Header-icon" to="/" exact="true">
                <img src={logoimg} alt="logo-image" className="logo" />
              </NavLink>
            </div>
          </div>
          {hideToggle && (
            <div className="fixed_bg_navbar">
              <div className="nav" id="myNav">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  className="toggle_close_icon"
                  onClick={closePriceDetails}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 13L13 1" stroke="#AAAAAA" strokeWidth="1.2" />
                  <path d="M13 13L1 1" stroke="#AAAAAA" strokeWidth="1.2" />
                </svg>

                <Link
                  to="/"
                  className={`flex_align_center Header_links ${activeLink === "holidays" ? "active" : ""
                    }`}
                  onClick={() => handleActive("holidays")}
                >
                  <span>
                    {activeLink === "holidays" ? (
                      <svg
                        className="Header_link_svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.6168 7.98696C14.4039 7.98593 14.1945 8.04113 14.0096 8.14701C13.8246 8.25293 13.6706 8.40583 13.563 8.59032C13.563 8.59038 13.5629 8.59045 13.5629 8.59052L11.8101 11.5636L8.74331 6.33371C8.63518 6.14906 8.4809 5.99592 8.2957 5.8895C8.11049 5.78307 7.9008 5.72707 7.68739 5.72707C7.47397 5.72707 7.26428 5.78307 7.07907 5.8895C6.89387 5.99592 6.73959 6.14906 6.63146 6.33371L1.49156 15.0973L1.49155 15.0974C1.43235 15.1984 1.40079 15.3132 1.40001 15.4304C1.39924 15.5475 1.42929 15.6628 1.48716 15.7646C1.54502 15.8664 1.62867 15.951 1.72966 16.0099L1.77976 15.9241L1.72966 16.0099C1.83065 16.0689 1.94539 16.1 2.06224 16.1H2.06228H18.9376C19.0546 16.1 19.1695 16.0688 19.2707 16.0098C19.3718 15.9507 19.4555 15.8658 19.5133 15.7638C19.5711 15.6618 19.601 15.5463 19.6 15.429C19.599 15.3117 19.5671 15.1967 19.5075 15.0957L15.6714 8.59045C15.6714 8.59039 15.6713 8.59033 15.6713 8.59027C15.5635 8.40578 15.4094 8.25291 15.2243 8.14701C15.0393 8.04115 14.8298 7.98595 14.6168 7.98696ZM14.6168 7.98696C14.617 7.98696 14.6172 7.98696 14.6173 7.98696L14.6168 8.08696L14.6163 7.98696C14.6165 7.98696 14.6166 7.98696 14.6168 7.98696ZM13.0312 7.05652C13.4405 7.05652 13.8405 6.93457 14.1808 6.70615C14.521 6.47773 14.7861 6.15312 14.9426 5.77342C15.0991 5.39373 15.1401 4.97595 15.0603 4.5729C14.9805 4.16985 14.7835 3.79956 14.4943 3.50888C14.205 3.21819 13.8363 3.02018 13.4349 2.93995C13.0335 2.85972 12.6175 2.9009 12.2394 3.05826C11.8613 3.21562 11.5382 3.48207 11.311 3.82383C11.0837 4.16558 10.9624 4.56733 10.9624 4.97826C10.9624 5.5293 11.1803 6.05786 11.5682 6.44764C11.9561 6.83745 12.4824 7.05652 13.0312 7.05652ZM13.0312 4.23044C13.1782 4.23044 13.322 4.27423 13.4443 4.35634C13.5666 4.43846 13.662 4.55522 13.7183 4.69192C13.7747 4.82863 13.7894 4.97909 13.7607 5.12424L13.8588 5.14366L13.7607 5.12425C13.732 5.2694 13.661 5.40267 13.557 5.50722C13.4529 5.61177 13.3204 5.68292 13.1762 5.71174C13.0321 5.74055 12.8826 5.72577 12.7468 5.66923C12.6109 5.61269 12.4947 5.5169 12.4129 5.39392C12.3311 5.27092 12.2875 5.12627 12.2875 4.97826C12.2875 4.77977 12.3659 4.58951 12.5055 4.4493C12.645 4.30911 12.8341 4.23044 13.0312 4.23044ZM6.20466 9.68261L7.68739 7.1542L9.17011 9.68261H6.20466ZM11.2392 13.2104L12.1535 14.7696H3.22125L5.42431 11.013H9.95046L11.2392 13.2104ZM17.778 14.7696H13.6911L12.5784 12.8717L14.6169 9.4142L17.778 14.7696Z"
                          fill="#EB442D"
                          stroke="#EB442D"
                          strokeWidth="0.2"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="Header_link_svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.6168 7.98696C14.4039 7.98593 14.1945 8.04113 14.0096 8.14701C13.8246 8.25293 13.6706 8.40583 13.563 8.59032C13.563 8.59038 13.5629 8.59045 13.5629 8.59052L11.8101 11.5636L8.74331 6.33371C8.63518 6.14906 8.4809 5.99592 8.2957 5.8895C8.11049 5.78307 7.9008 5.72707 7.68739 5.72707C7.47397 5.72707 7.26428 5.78307 7.07907 5.8895C6.89387 5.99592 6.73959 6.14906 6.63146 6.33371L1.49156 15.0973L1.49155 15.0974C1.43235 15.1984 1.40079 15.3132 1.40001 15.4304C1.39924 15.5475 1.42929 15.6628 1.48716 15.7646C1.54502 15.8664 1.62867 15.951 1.72966 16.0099L1.77976 15.9241L1.72966 16.0099C1.83065 16.0689 1.94539 16.1 2.06224 16.1H2.06228H18.9376C19.0546 16.1 19.1695 16.0688 19.2707 16.0098C19.3718 15.9507 19.4555 15.8658 19.5133 15.7638C19.5711 15.6618 19.601 15.5463 19.6 15.429C19.599 15.3117 19.5671 15.1967 19.5075 15.0957L15.6714 8.59045C15.6714 8.59039 15.6713 8.59033 15.6713 8.59027C15.5635 8.40578 15.4094 8.25291 15.2243 8.14701C15.0393 8.04115 14.8298 7.98595 14.6168 7.98696ZM14.6168 7.98696C14.617 7.98696 14.6172 7.98696 14.6173 7.98696L14.6168 8.08696L14.6163 7.98696C14.6165 7.98696 14.6166 7.98696 14.6168 7.98696ZM13.0312 7.05652C13.4405 7.05652 13.8405 6.93457 14.1808 6.70615C14.521 6.47773 14.7861 6.15312 14.9426 5.77342C15.0991 5.39373 15.1401 4.97595 15.0603 4.5729C14.9805 4.16985 14.7835 3.79956 14.4943 3.50888C14.205 3.21819 13.8363 3.02018 13.4349 2.93995C13.0335 2.85972 12.6175 2.9009 12.2394 3.05826C11.8613 3.21562 11.5382 3.48207 11.311 3.82383C11.0837 4.16558 10.9624 4.56733 10.9624 4.97826C10.9624 5.5293 11.1803 6.05786 11.5682 6.44764C11.9561 6.83745 12.4824 7.05652 13.0312 7.05652ZM13.0312 4.23044C13.1782 4.23044 13.322 4.27423 13.4443 4.35634C13.5666 4.43846 13.662 4.55522 13.7183 4.69192C13.7747 4.82863 13.7894 4.97909 13.7607 5.12424L13.8588 5.14366L13.7607 5.12425C13.732 5.2694 13.661 5.40267 13.557 5.50722C13.4529 5.61177 13.3204 5.68292 13.1762 5.71174C13.0321 5.74055 12.8826 5.72577 12.7468 5.66923C12.6109 5.61269 12.4947 5.5169 12.4129 5.39392C12.3311 5.27092 12.2875 5.12627 12.2875 4.97826C12.2875 4.77977 12.3659 4.58951 12.5055 4.4493C12.645 4.30911 12.8341 4.23044 13.0312 4.23044ZM6.20466 9.68261L7.68739 7.1542L9.17011 9.68261H6.20466ZM11.2392 13.2104L12.1535 14.7696H3.22125L5.42431 11.013H9.95046L11.2392 13.2104ZM17.778 14.7696H13.6911L12.5784 12.8717L14.6169 9.4142L17.778 14.7696Z"
                          fill="#333333"
                          stroke="#333333"
                          strokeWidth="0.2"
                        />
                      </svg>
                    )}
                  </span>
                  <span>Holidays</span>
                </Link>
                <Link
                  to="/accommodation"
                  className={`flex_align_center Header_links ${activeLink === "hotel" ? "active" : ""
                    }`}
                  onClick={() => handleActive("hotel")}
                >
                  <span>
                    {activeLink === "hotel" ? (
                      <svg
                        className="Header_link_svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                          fill="#EB442D"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="Header_link_svg_active"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                          fill="#333333"
                        />
                      </svg>
                    )}
                  </span>
                  <span>Hotels</span>
                </Link>
                <Link
                  to="/transport"
                  className={`flex_align_center Header_links ${activeLink === "transport" ? "active" : ""
                    }`}
                  onClick={() => handleActive("transport")}
                >
                  <span>
                    {activeLink === "transport" ? (
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#EB442D"><path d="M240-240v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-312l78-195q8-20 26-32.5t41-12.5h95v-72h192v72h95q22.42 0 40.71 12.5T738-699l78 195v312q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-48H240Zm1-312h479l-48-120H289l-48 120Zm-25 72v168-168Zm96 132q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm336 0q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-432 36h528v-168H216v168Z" /></svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#333333"><path d="M240-240v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-312l78-195q8-20 26-32.5t41-12.5h95v-72h192v72h95q22.42 0 40.71 12.5T738-699l78 195v312q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-48H240Zm1-312h479l-48-120H289l-48 120Zm-25 72v168-168Zm96 132q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm336 0q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-432 36h528v-168H216v168Z" /></svg>
                    )}
                  </span>
                  <span>Transport</span>
                </Link>
                <Link
                  to="/activities"
                  className={`flex_align_center Header_links ${activeLink === "activities" ? "active" : ""
                    }`}
                  onClick={() => handleActive("activities")}
                >
                  <span>
                    {activeLink === "activities" ? (
                      <svg
                        className="Header_link_svg"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                          fill="#EB442D"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="Header_link_svg_active"
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                          fill="#333333"
                        />
                      </svg>
                    )}
                  </span>
                  <span>Activities</span>
                </Link>

              </div>
            </div>
          )}

          <div className="flex Header_links_wraper hidden-sm">
            <Link
              to="/"
              className={`flex_align_center Header_links ${activeLink === "holidays" ? "active" : ""
                }`}
              onClick={() => handleActive("holidays")}
            >
              <span>
                {activeLink === "holidays" ? (
                  <svg
                    className="Header_link_svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6168 7.98696C14.4039 7.98593 14.1945 8.04113 14.0096 8.14701C13.8246 8.25293 13.6706 8.40583 13.563 8.59032C13.563 8.59038 13.5629 8.59045 13.5629 8.59052L11.8101 11.5636L8.74331 6.33371C8.63518 6.14906 8.4809 5.99592 8.2957 5.8895C8.11049 5.78307 7.9008 5.72707 7.68739 5.72707C7.47397 5.72707 7.26428 5.78307 7.07907 5.8895C6.89387 5.99592 6.73959 6.14906 6.63146 6.33371L1.49156 15.0973L1.49155 15.0974C1.43235 15.1984 1.40079 15.3132 1.40001 15.4304C1.39924 15.5475 1.42929 15.6628 1.48716 15.7646C1.54502 15.8664 1.62867 15.951 1.72966 16.0099L1.77976 15.9241L1.72966 16.0099C1.83065 16.0689 1.94539 16.1 2.06224 16.1H2.06228H18.9376C19.0546 16.1 19.1695 16.0688 19.2707 16.0098C19.3718 15.9507 19.4555 15.8658 19.5133 15.7638C19.5711 15.6618 19.601 15.5463 19.6 15.429C19.599 15.3117 19.5671 15.1967 19.5075 15.0957L15.6714 8.59045C15.6714 8.59039 15.6713 8.59033 15.6713 8.59027C15.5635 8.40578 15.4094 8.25291 15.2243 8.14701C15.0393 8.04115 14.8298 7.98595 14.6168 7.98696ZM14.6168 7.98696C14.617 7.98696 14.6172 7.98696 14.6173 7.98696L14.6168 8.08696L14.6163 7.98696C14.6165 7.98696 14.6166 7.98696 14.6168 7.98696ZM13.0312 7.05652C13.4405 7.05652 13.8405 6.93457 14.1808 6.70615C14.521 6.47773 14.7861 6.15312 14.9426 5.77342C15.0991 5.39373 15.1401 4.97595 15.0603 4.5729C14.9805 4.16985 14.7835 3.79956 14.4943 3.50888C14.205 3.21819 13.8363 3.02018 13.4349 2.93995C13.0335 2.85972 12.6175 2.9009 12.2394 3.05826C11.8613 3.21562 11.5382 3.48207 11.311 3.82383C11.0837 4.16558 10.9624 4.56733 10.9624 4.97826C10.9624 5.5293 11.1803 6.05786 11.5682 6.44764C11.9561 6.83745 12.4824 7.05652 13.0312 7.05652ZM13.0312 4.23044C13.1782 4.23044 13.322 4.27423 13.4443 4.35634C13.5666 4.43846 13.662 4.55522 13.7183 4.69192C13.7747 4.82863 13.7894 4.97909 13.7607 5.12424L13.8588 5.14366L13.7607 5.12425C13.732 5.2694 13.661 5.40267 13.557 5.50722C13.4529 5.61177 13.3204 5.68292 13.1762 5.71174C13.0321 5.74055 12.8826 5.72577 12.7468 5.66923C12.6109 5.61269 12.4947 5.5169 12.4129 5.39392C12.3311 5.27092 12.2875 5.12627 12.2875 4.97826C12.2875 4.77977 12.3659 4.58951 12.5055 4.4493C12.645 4.30911 12.8341 4.23044 13.0312 4.23044ZM6.20466 9.68261L7.68739 7.1542L9.17011 9.68261H6.20466ZM11.2392 13.2104L12.1535 14.7696H3.22125L5.42431 11.013H9.95046L11.2392 13.2104ZM17.778 14.7696H13.6911L12.5784 12.8717L14.6169 9.4142L17.778 14.7696Z"
                      fill="#EB442D"
                      stroke="#EB442D"
                      strokeWidth="0.2"
                    />
                  </svg>
                ) : (
                  <svg
                    className="Header_link_svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.6168 7.98696C14.4039 7.98593 14.1945 8.04113 14.0096 8.14701C13.8246 8.25293 13.6706 8.40583 13.563 8.59032C13.563 8.59038 13.5629 8.59045 13.5629 8.59052L11.8101 11.5636L8.74331 6.33371C8.63518 6.14906 8.4809 5.99592 8.2957 5.8895C8.11049 5.78307 7.9008 5.72707 7.68739 5.72707C7.47397 5.72707 7.26428 5.78307 7.07907 5.8895C6.89387 5.99592 6.73959 6.14906 6.63146 6.33371L1.49156 15.0973L1.49155 15.0974C1.43235 15.1984 1.40079 15.3132 1.40001 15.4304C1.39924 15.5475 1.42929 15.6628 1.48716 15.7646C1.54502 15.8664 1.62867 15.951 1.72966 16.0099L1.77976 15.9241L1.72966 16.0099C1.83065 16.0689 1.94539 16.1 2.06224 16.1H2.06228H18.9376C19.0546 16.1 19.1695 16.0688 19.2707 16.0098C19.3718 15.9507 19.4555 15.8658 19.5133 15.7638C19.5711 15.6618 19.601 15.5463 19.6 15.429C19.599 15.3117 19.5671 15.1967 19.5075 15.0957L15.6714 8.59045C15.6714 8.59039 15.6713 8.59033 15.6713 8.59027C15.5635 8.40578 15.4094 8.25291 15.2243 8.14701C15.0393 8.04115 14.8298 7.98595 14.6168 7.98696ZM14.6168 7.98696C14.617 7.98696 14.6172 7.98696 14.6173 7.98696L14.6168 8.08696L14.6163 7.98696C14.6165 7.98696 14.6166 7.98696 14.6168 7.98696ZM13.0312 7.05652C13.4405 7.05652 13.8405 6.93457 14.1808 6.70615C14.521 6.47773 14.7861 6.15312 14.9426 5.77342C15.0991 5.39373 15.1401 4.97595 15.0603 4.5729C14.9805 4.16985 14.7835 3.79956 14.4943 3.50888C14.205 3.21819 13.8363 3.02018 13.4349 2.93995C13.0335 2.85972 12.6175 2.9009 12.2394 3.05826C11.8613 3.21562 11.5382 3.48207 11.311 3.82383C11.0837 4.16558 10.9624 4.56733 10.9624 4.97826C10.9624 5.5293 11.1803 6.05786 11.5682 6.44764C11.9561 6.83745 12.4824 7.05652 13.0312 7.05652ZM13.0312 4.23044C13.1782 4.23044 13.322 4.27423 13.4443 4.35634C13.5666 4.43846 13.662 4.55522 13.7183 4.69192C13.7747 4.82863 13.7894 4.97909 13.7607 5.12424L13.8588 5.14366L13.7607 5.12425C13.732 5.2694 13.661 5.40267 13.557 5.50722C13.4529 5.61177 13.3204 5.68292 13.1762 5.71174C13.0321 5.74055 12.8826 5.72577 12.7468 5.66923C12.6109 5.61269 12.4947 5.5169 12.4129 5.39392C12.3311 5.27092 12.2875 5.12627 12.2875 4.97826C12.2875 4.77977 12.3659 4.58951 12.5055 4.4493C12.645 4.30911 12.8341 4.23044 13.0312 4.23044ZM6.20466 9.68261L7.68739 7.1542L9.17011 9.68261H6.20466ZM11.2392 13.2104L12.1535 14.7696H3.22125L5.42431 11.013H9.95046L11.2392 13.2104ZM17.778 14.7696H13.6911L12.5784 12.8717L14.6169 9.4142L17.778 14.7696Z"
                      fill="#333333"
                      stroke="#333333"
                      strokeWidth="0.2"
                    />
                  </svg>
                )}
              </span>
              <span>Holidays</span>
            </Link>
            <Link
              to="/accommodation"
              className={`flex_align_center Header_links ${activeLink === "hotel" ? "active" : ""
                }`}
              onClick={() => handleActive("hotel")}
            >
              <span>
                {activeLink === "hotel" ? (
                  <svg
                    className="Header_link_svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                      fill="#EB442D"
                    />
                  </svg>
                ) : (
                  <svg
                    className="Header_link_svg_active"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                      fill="#333333"
                    />
                  </svg>
                )}
              </span>
              <span>Hotels</span>
            </Link>
            <Link
              to="/transport"
              className={`flex_align_center Header_links ${activeLink === "transport" ? "active" : ""
                }`}
              onClick={() => handleActive("transport")}
            >
              <span>
                {activeLink === "transport" ? (
                  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#EB442D"><path d="M240-240v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-312l78-195q8-20 26-32.5t41-12.5h95v-72h192v72h95q22.42 0 40.71 12.5T738-699l78 195v312q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-48H240Zm1-312h479l-48-120H289l-48 120Zm-25 72v168-168Zm96 132q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm336 0q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-432 36h528v-168H216v168Z" /></svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#333333"><path d="M240-240v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-312l78-195q8-20 26-32.5t41-12.5h95v-72h192v72h95q22.42 0 40.71 12.5T738-699l78 195v312q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-48q-10.2 0-17.1-6.9-6.9-6.9-6.9-17.1v-48H240Zm1-312h479l-48-120H289l-48 120Zm-25 72v168-168Zm96 132q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm336 0q20 0 34-14t14-34q0-20-14-34t-34-14q-20 0-34 14t-14 34q0 20 14 34t34 14Zm-432 36h528v-168H216v168Z" /></svg>
                )}
              </span>
              <span>Transport</span>
            </Link>
            <Link
              to="/activities"
              className={`flex_align_center Header_links ${activeLink === "activities" ? "active" : ""
                }`}
              onClick={() => handleActive("activities")}
            >
              <span>
                {activeLink === "activities" ? (
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2.375C5.52 2.375 1.875 6.02 1.875 10.5C1.875 14.98 5.52 18.625 10 18.625C14.48 18.625 18.125 14.98 18.125 10.5C18.125 6.02 14.48 2.375 10 2.375ZM9.29688 3.66438C9.32188 3.66125 9.34937 3.66625 9.375 3.66438V4.25H10.625V3.66375C12.2242 3.80681 13.7222 4.50716 14.8575 5.64246C15.9928 6.77776 16.6932 8.27583 16.8363 9.875H16.25V11.125H16.8363C16.6932 12.7242 15.9928 14.2222 14.8575 15.3575C13.7222 16.4928 12.2242 17.1932 10.625 17.3363V16.75H9.375V17.3363C7.77583 17.1932 6.27776 16.4928 5.14246 15.3575C4.00716 14.2222 3.30681 12.7242 3.16375 11.125H3.75V9.875H3.16375C3.45875 6.59812 6.03063 3.99375 9.29688 3.66375V3.66438ZM13.8094 6.69125L8.49688 8.99625L6.19062 14.3088L11.5031 12.0037L13.8094 6.69125ZM10 9.5625C10.5 9.5625 10.9375 10 10.9375 10.5C10.9375 11 10.5 11.4375 10 11.4375C9.5 11.4375 9.0625 11 9.0625 10.5C9.0625 10 9.5 9.5625 10 9.5625Z"
                      fill="#EB442D"
                    />
                  </svg>
                ) : (
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 2.375C5.52 2.375 1.875 6.02 1.875 10.5C1.875 14.98 5.52 18.625 10 18.625C14.48 18.625 18.125 14.98 18.125 10.5C18.125 6.02 14.48 2.375 10 2.375ZM9.29688 3.66438C9.32188 3.66125 9.34937 3.66625 9.375 3.66438V4.25H10.625V3.66375C12.2242 3.80681 13.7222 4.50716 14.8575 5.64246C15.9928 6.77776 16.6932 8.27583 16.8363 9.875H16.25V11.125H16.8363C16.6932 12.7242 15.9928 14.2222 14.8575 15.3575C13.7222 16.4928 12.2242 17.1932 10.625 17.3363V16.75H9.375V17.3363C7.77583 17.1932 6.27776 16.4928 5.14246 15.3575C4.00716 14.2222 3.30681 12.7242 3.16375 11.125H3.75V9.875H3.16375C3.45875 6.59812 6.03063 3.99375 9.29688 3.66375V3.66438ZM13.8094 6.69125L8.49688 8.99625L6.19062 14.3088L11.5031 12.0037L13.8094 6.69125ZM10 9.5625C10.5 9.5625 10.9375 10 10.9375 10.5C10.9375 11 10.5 11.4375 10 11.4375C9.5 11.4375 9.0625 11 9.0625 10.5C9.0625 10 9.5 9.5625 10 9.5625Z"
                      fill="#222222"
                    />
                  </svg>
                )}
              </span>
              <span>Activities</span>
            </Link>
            {/* 
            <Link
              to="/transport"
              className={`flex_align_center Header_links ${activeLink === "transport" ? "active" : ""
                }`}
              onClick={() => handleActive("transport")}
            >
              <span>
                {activeLink === "transport" ? (
                  <svg
                    className="Header_link_svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                      fill="#EB442D"
                    />
                  </svg>
                ) : (
                  <svg
                    className="Header_link_svg_active"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.8346 18H2.16797V16.3333H3.0013V3.83333C3.0013 3.61232 3.0891 3.40036 3.24538 3.24408C3.40166 3.0878 3.61362 3 3.83464 3H15.5013C15.7223 3 15.9343 3.0878 16.0906 3.24408C16.2468 3.40036 16.3346 3.61232 16.3346 3.83333V8H18.0013V16.3333H18.8346V18ZM14.668 16.3333H16.3346V9.66667H11.3346V16.3333H13.0013V11.3333H14.668V16.3333ZM14.668 8V4.66667H4.66797V16.3333H9.66797V8H14.668ZM6.33464 9.66667H8.0013V11.3333H6.33464V9.66667ZM6.33464 13H8.0013V14.6667H6.33464V13ZM6.33464 6.33333H8.0013V8H6.33464V6.33333Z"
                      fill="#333333"
                    />
                  </svg>
                )}
              </span>
              <span>Transport</span>
            </Link> */}
          </div>

          <div className="flex flex_gap_10">
            {isLoggedIn ? (
              <div className="Main-header-btn">
                <AccountDetailDropdown
                  name={name}
                  userType={userType}
                  handleLogout={handleLogout}
                />
              </div>
            ) : (
              <div className="Mainregister-btn Main-header-btn">
                <LoginBtn />
              </div>
            )}

            <div className="support_btn cursor_pointer">
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_2485_129"
                  style={{ maskType: "alpha" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="16"
                  height="17"
                >
                  <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2485_129)">
                  <path
                    d="M8 15.8335V14.5002H12.6667V13.8335H10V8.50016H12.6667V7.8335C12.6667 6.54461 12.2111 5.44461 11.3 4.5335C10.3889 3.62239 9.28889 3.16683 8 3.16683C6.71111 3.16683 5.61111 3.62239 4.7 4.5335C3.78889 5.44461 3.33333 6.54461 3.33333 7.8335V8.50016H6V13.8335H3.33333C2.96667 13.8335 2.65278 13.7029 2.39167 13.4418C2.13056 13.1807 2 12.8668 2 12.5002V7.8335C2 7.01127 2.15833 6.23627 2.475 5.5085C2.79167 4.78072 3.22222 4.14461 3.76667 3.60016C4.31111 3.05572 4.94722 2.62516 5.675 2.3085C6.40278 1.99183 7.17778 1.8335 8 1.8335C8.82222 1.8335 9.59722 1.99183 10.325 2.3085C11.0528 2.62516 11.6889 3.05572 12.2333 3.60016C12.7778 4.14461 13.2083 4.78072 13.525 5.5085C13.8417 6.23627 14 7.01127 14 7.8335V14.5002C14 14.8668 13.8694 15.1807 13.6083 15.4418C13.3472 15.7029 13.0333 15.8335 12.6667 15.8335H8ZM3.33333 12.5002H4.66667V9.8335H3.33333V12.5002ZM11.3333 12.5002H12.6667V9.8335H11.3333V12.5002Z"
                    fill="#333333"
                  />
                </g>
              </svg>
              Support
              <div className="supportDetails">
                <Link className="flex" to="tel:+919805021966">
                  <span className="supportSvg">
                    <svg
                      className="m_0"
                      width="18"
                      height="19"
                      viewBox="0 0 18 19"
                      fill="#FFFFFF"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2263_992"
                        style={{
                          maskType: "alpha",
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "18",
                          height: "19",
                        }}
                      >
                        <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_2263_992)">
                        <path
                          d="M14.9625 16.25C13.4 16.25 11.8563 15.9094 10.3313 15.2281C8.80625 14.5469 7.41875 13.5813 6.16875 12.3313C4.91875 11.0813 3.95312 9.69375 3.27188 8.16875C2.59063 6.64375 2.25 5.1 2.25 3.5375C2.25 3.3125 2.325 3.125 2.475 2.975C2.625 2.825 2.8125 2.75 3.0375 2.75H6.075C6.25 2.75 6.40625 2.80937 6.54375 2.92812C6.68125 3.04688 6.7625 3.1875 6.7875 3.35L7.275 5.975C7.3 6.175 7.29375 6.34375 7.25625 6.48125C7.21875 6.61875 7.15 6.7375 7.05 6.8375L5.23125 8.675C5.48125 9.1375 5.77812 9.58437 6.12187 10.0156C6.46562 10.4469 6.84375 10.8625 7.25625 11.2625C7.64375 11.65 8.05 12.0094 8.475 12.3406C8.9 12.6719 9.35 12.975 9.825 13.25L11.5875 11.4875C11.7 11.375 11.8469 11.2906 12.0281 11.2344C12.2094 11.1781 12.3875 11.1625 12.5625 11.1875L15.15 11.7125C15.325 11.7625 15.4688 11.8531 15.5812 11.9844C15.6937 12.1156 15.75 12.2625 15.75 12.425V15.4625C15.75 15.6875 15.675 15.875 15.525 16.025C15.375 16.175 15.1875 16.25 14.9625 16.25ZM4.51875 7.25L5.75625 6.0125L5.4375 4.25H3.76875C3.83125 4.7625 3.91875 5.26875 4.03125 5.76875C4.14375 6.26875 4.30625 6.7625 4.51875 7.25ZM11.2313 13.9625C11.7188 14.175 12.2156 14.3438 12.7219 14.4688C13.2281 14.5938 13.7375 14.675 14.25 14.7125V13.0625L12.4875 12.7063L11.2313 13.9625Z"
                          fill="#000"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>
                    <b style={{ fontSize: "12px" }}>Call Support</b>
                    <br />
                    <span style={{ color: "#016937" }}>+91-98050-21966</span>
                  </span>
                </Link>
                <Link className="flex" to="mailto:info@mountainmysteries.com">
                  <span className="supportSvg">
                    <svg
                      className="m_0"
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_2263_999"
                        style={{
                          maskType: "alpha",
                          maskUnits: "userSpaceOnUse",
                          x: "0",
                          y: "0",
                          width: "18",
                          height: "19",
                        }}
                      >
                        <rect
                          x="0.333374"
                          y="0.5"
                          width="18"
                          height="18"
                          fill="#D9D9D9"
                        />
                      </mask>
                      <g mask="url(#mask0_2263_999)">
                        <path
                          d="M3.33337 15.5C2.92087 15.5 2.56775 15.3531 2.274 15.0594C1.98025 14.7656 1.83337 14.4125 1.83337 14V5C1.83337 4.5875 1.98025 4.23438 2.274 3.94063C2.56775 3.64688 2.92087 3.5 3.33337 3.5H15.3334C15.7459 3.5 16.099 3.64688 16.3927 3.94063C16.6865 4.23438 16.8334 4.5875 16.8334 5V14C16.8334 14.4125 16.6865 14.7656 16.3927 15.0594C16.099 15.3531 15.7459 15.5 15.3334 15.5H3.33337ZM9.33337 10.25L3.33337 6.5V14H15.3334V6.5L9.33337 10.25ZM9.33337 8.75L15.3334 5H3.33337L9.33337 8.75ZM3.33337 6.5V5V14V6.5Z"
                          fill="#000"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>
                    <b style={{ fontSize: "12px" }}>Mail Support</b>
                    <br />
                    <span style={{ color: "#016937" }}>
                      {" "}
                      info@mountainmysteries.com
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
